export const workflowData = {
  configuration: {
    title: 'Google Sheet Integration',
    description: 'Organization-level integration with Google Sheets to manage multiple sheet files',
  },
  phases: [
    {
      name: 'Initial Setup & Planning Phase',
      steps: [
        { title: 'Project Creation', details: 'Create project with basic details, automatically generating 2 sheet files (planned and actual)' },
        { title: 'Upload Requirement Files', details: 'Support for upload requirement files received from Project managers and finance teams (Excel files)' },
        { title: 'AI Analysis & Verification', details: 'Tymeline AI Engine extracts and displays data for review and verification' },
        { title: 'Project Kick-off', details: 'Final verification and approval to start the project (with some suitable charts)' },
        { title: 'Kick-off Visualization', details: 'Show data in graphs for better visualization of requirements and the overall project' },
      ],
      sheets: {
        title: 'Sheet File 1: Planned Data',
        items: [
          'Sheet 1: Labor Requirements (man months/hours, roles)',
          'Sheet 2: Labor Cost Requirements (role and cost)',
          'Sheet 3: Additional Cost Requirements (boards, lab, chip)'
        ]
      }
    },  
    {
      name: 'Project Execution Phase',
      steps: [
        { title: 'Project Dashboard', details: 'View actual vs planned charts and insights with variance analysis' },
        { title: 'Feature to Edit Budget(Planned) Data', details: 'Option to edit budget(planned) data if change in budget' },
        { title: 'Upload Actual Data', details: 'Upload Excel files recived from Project managers with actual project data' },
        { title: 'AI Analysis & Verification for Actual Data', details: 'Tymeline AI Engine extracts and displays actual data for review' },
        { title: 'Update Actual Data', details: 'Approved data is updated in Google Sheet File 2 (Actual Data)' },
      ],
      sheets: {
        title: 'Sheet File 2: Actual Data',
        items: [
          'Sheet 1: Labor Actuals (man months/hours for roles)',
          'Sheet 2: Additional Cost Actuals (boards, lab, chip)'
        ]
      }
    }
  ],
  charts: {
    plannedVsActual: [
      { label: 'Labor', height: '80%', type: 'planned' },
      { label: 'Actual', height: '65%', type: 'actual' },
      { label: 'Cost', height: '60%', type: 'planned' },
      { label: 'Actual', height: '75%', type: 'actual' },
      { label: 'Boards', height: '45%', type: 'planned' },
      { label: 'Actual', height: '40%', type: 'actual' },
    ]
  },
  approvals: {
    current: [
      'Admin uploads data',
      'Admin verifies and approves data',
      'Data directly updates Google Sheet'
    ],
    future: [
      'Project manager uploads data',
      'Project manager verifies data',
      'Request sent to admin for approval',
      'Admin approves data',
      'Data updates Google Sheet'
    ]
  },
  additional: [
    'Cloud Excel file support will give a feel that they are not complexly moving from their current way of handling data',
    'Future support to add more members that they can directly upload the project/budget details and get approved',
    'Adding detailed member details or importing member details with availability and other details in future can give more accurate future forecast and other insights'
  ]
};


